<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/binder-pdf-signature"
                saveRoot="/binder-pdf-signature"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.binderPDFSignature">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/binder-pdf-signature"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la signature')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette signature?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'BinderPDFSignature',
        components: {
            DynamicForm,
            ModalTrash
        },
        props: {
            value: {
                type: Number | String,
                default: ''
            }
        },
        mounted() {
            this.dataId = this.value
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    binderPDFSignature: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Signature'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'image'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'image',
                                type: 'image',
                                label: Core.Definition.getDefinition('Image'),
                                value: []
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
            }
        }
    }
</script>
